import React from 'react';
import PropTypes from 'prop-types';
import {View, Preloader, IPeriod, IDate} from '@ab/components';
import mainTpl from '../templates/main';
import {ALL_CATEGORIES} from '../variables';
import {api, get} from '../../../config';
import mixins from '../../../mixins';

class Main extends View {
    templates = {
        [this.uiStates.INITIAL]: <div />,
        [this.uiStates.STANDBY]: <Preloader />,
        [this.uiStates.PROCESSING]: mainTpl,
        [this.uiStates.INTERACTIVE]: mainTpl,
        [this.uiStates.ERROR]: mainTpl,
    };

    fetchBeforeRender = ['settings'];

    constructor(props) {
        super(props);
        this.state = {
            ui: this.uiStates.INITIAL,
            period: '',
            quarter: null,
            quarterIndex: 0,
            category: props.category,
            collection: [],
            lastDateTimeLong: null,
            isDisabledShowMore: false,
            dateInput: null,
            openFilters: false,
            openCalendar: false,
            activeFilterId: '',
        };
        this.max_count = 30;
        this.dateInputRef = React.createRef();
        this.buttonRef = React.createRef();
        return this;
    }

    async componentReady() {
        // this.load();
        await this.getStatements({date_to: new Date(Date.now())});
    }

    async componentDidUpdate(prevProps, prevState) {
        if (prevState.period !== this.state.period) {
            if (!this.state.quarter) {
                this.load();
            }

            if (this.state.quarter) {
                // Первый запуск для квартала
                await this.getStatements({
                    ...this.state.quarter[this.state.quarterIndex],
                    type: 'quarter',
                });
                this.setState({
                    quarterIndex: this.state.quarterIndex + 1,
                });
            }
        }
    }

    async showMore() {
        const {lastDateTimeLong, collection, quarterIndex, quarter} = this.state;

        if (!quarterIndex) {
            let date_to = lastDateTimeLong;
            const lastCollection = collection[collection.length - 1]?.date_time_long;
            const lastDoubleCollection = collection[collection.length - 2]?.date_time_long;
            const isDouble = lastDoubleCollection === lastCollection;

            const getLastDateTimeLong = () => {
                const updatedCollection = [];
                let dateTimeLong;

                collection.forEach(el => {
                    if (el.date_time_long === lastCollection) {
                        updatedCollection.push({...el, isDouble: true});
                    } else {
                        updatedCollection.push(el);
                    }
                });

                for (let i = collection.length - 1; i >= 0; i--) {
                    if (collection[i].date_time_long !== lastCollection) {
                        dateTimeLong = collection[i].date_time_long;
                        break;
                    }
                }

                this.setState({collection: updatedCollection});

                return dateTimeLong;
            };

            if (isDouble) {
                date_to = getLastDateTimeLong();
            } else {
                date_to = date_to ? date_to : lastCollection;
            }

            await this.getStatements({date_from: null, date_to, isDouble});
        }

        if (quarterIndex > 0) {
            // Второй и третий запуск для квартала
            await this.getStatements({
                ...this.state.quarter[this.state.quarterIndex],
                type: 'quarter',
            });
            this.setState({
                quarterIndex: this.state.quarterIndex + 1,
            });
        }
    }

    getTotals(list) {
        let income = 0,
            spend = 0;
        list.forEach(model => {
            const amount = model.account_amount.value;
            if (amount) {
                if (amount < 0) {
                    spend += amount;
                } else {
                    income += amount;
                }
            }
        });

        return {
            income,
            spend,
        };
    }

    async getStatements({date_from, date_to, type, isDouble}) {
        const data = {
            max_count: this.max_count,
            date_from: date_from ? +date_from : null,
            date_to: +date_to,
            hash_pan: this.props.model.attributes.hashPan,
        };
        const response = await fetch(api('API_STATEMENTS_TRANSACTION'), {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json;charset=utf-8',
                },
                body: JSON.stringify({
                    lang: get('LANG'),
                    request_ref: mixins.requestRefUuid(),
                    sid: mixins.getCookie('skey'),
                    data: data,
                }),
            }),
            newResData = [],
            result = await response.json();
        const transactions = [...result.data.transactions];
        const lastDateTimeLong = transactions[transactions.length - 1]?.date_time_long;

        this.setState({lastDateTimeLong});

        if (transactions.length === 0) {
            this.setState({
                isDisabledShowMore: true,
            });
        }

        transactions.map(item => {
            return Object.keys(item).some(key => {
                if (key === 'account_amount') {
                    newResData.push(item);
                }
            });
        });

        const isPeriod = date_from && date_to;
        const isQuarter = type === 'quarter';

        if (!isPeriod && !isQuarter) {
            let collection = [...this.state.collection];
            if (isDouble) {
                collection = collection.filter(t => !t.isDouble);
            }
            collection = [...collection, ...newResData];
            this.setState({collection});
        }

        if (isPeriod) {
            this.setState({
                collection: newResData,
                // isDisabledShowMore:
                //     transactions.length < this.max_count - 1 ||
                //     !transactions.length,
            });
        }

        if (isQuarter) {
            this.setState({
                collection: newResData,
                isDisabledShowMore:
                    transactions.length < this.max_count - 1 ||
                    !transactions.length ||
                    this.state.quarterIndex === 2,
            });
        }
    }

    load = () => {
        let {period} = this.state,
            {model} = this.props;
        if (model) {
            return this.uiProcessing()
                .then(async () => {
                    period = new IPeriod(period);
                    const error = this.validate({period});
                    if (error) {
                        return Promise.reject(error);
                    } else {
                        const periods = this.state.period.split('-');
                        const data = {};
                        const dateFrom = {};
                        const dateTo = {};
                        const getIndexName = index => {
                            if (index === 0) return 'day';
                            if (index === 1) return 'mounth';
                            if (index === 2) return 'year';
                        };
                        periods[0]
                            .split('.')
                            .forEach((el, index) => (dateFrom[getIndexName(index)] = el));
                        periods[1]
                            .split('.')
                            .forEach((el, index) => (dateTo[getIndexName(index)] = el));

                        data.date_from = new Date(dateFrom.year, dateFrom.mounth - 1, dateFrom.day);
                        data.date_to = new Date(dateTo.year, dateTo.mounth - 1, dateTo.day);

                        await this.getStatements(data);
                    }
                })
                .then(() => {
                    return this.uiInteractive();
                })
                .catch(error => {
                    return this.errorHandler(error);
                });
        } else {
            return Promise.resolve();
        }
    };

    validate(data = {}) {
        let error,
            {period} = data;

        if (period && period.getUnitDifference() > 60) {
            error = {
                message: 'STATEMENTS_ERROR_PERIOD_RANGE',
                name: 'period',
            };
        }

        return error;
    }
    getPeriodFromType = type => {
        const d = new Date();
        const month = d.getMonth() + 1;
        const fullYear = d.getFullYear();
        const quarters = {
            1: [0, 1, 2],
            2: [3, 4, 5],
            3: [6, 7, 8],
            4: [9, 10, 11],
        };
        const getLastDayOfMonth = (year, month) => {
            this._clearPeriod();
            let date = new Date(year, month + 1, 0);
            return date.getDate();
        };
        const getQuarter = () => {
            return Math.floor((d.getMonth() + 3) / 3);
        };
        const getPrevWeek = () => {
            this._clearPeriod();

            const d = new Date();
            const date = d.getDate();
            const dayNumber = d.getDay();
            const startDate = new Date(d.setDate(date - (dayNumber - 1) - 7));
            const endDate = new Date(d.setDate(startDate.getDate() + 6));
            return {
                start: `${startDate.getDate()}.${startDate.getMonth() + 1}.${fullYear}`,
                end: `${endDate.getDate()}.${endDate.getMonth() + 1}.${fullYear}`,
            };
        };
        const getCurrMonth = () => {
            this._clearPeriod();
            return `01.${month}.${fullYear}`;
        };
        const getPrevMonth = () => {
            this._clearPeriod();

            const prevMonth = month === 1 ? 12 : month;
            const prevYear = month === 1 ? fullYear - 1 : fullYear;

            return {
                start: `01.${prevMonth - 1}.${prevYear}`,
                end: `${getLastDayOfMonth(prevYear, prevMonth)}.${prevMonth - 1}.${prevYear}`,
            };
        };
        const getQuarterFunc = months => {
            const data = {};
            const dataTimestamp = {};

            months.forEach((month, index) => {
                const lastDay = getLastDayOfMonth(fullYear, month + 1);
                dataTimestamp[index] = {
                    date_from: new Date(fullYear, month, 1),
                    date_to: new Date(fullYear, month, lastDay),
                };
                data[index] = {
                    date_from: `01.${month + 1}.${fullYear}`,
                    date_to: `${lastDay}.${month + 1}.${fullYear}`,
                };
            });

            this.setState({
                quarter: dataTimestamp,
                collection: [],
                quarterIndex: 0,
            });

            return {
                start: data[0].date_from,
                end: data[2].date_to,
            };
        };
        const getCurrQuarter = () => {
            const months = quarters[getQuarter()];
            const result = getQuarterFunc(months);
            result.end = `${d.getDate()}.${month}.${fullYear}`;

            return result;
        };
        const getPrevQuarter = () => {
            const quarter = getQuarter() - 1;
            const isPrevYear = quarter === 0;
            const months = quarters[quarter === 0 ? 4 : quarter];

            const result = getQuarterFunc(months);

            if (isPrevYear) {
                result.start = `01.10.${fullYear - 1}`;
            }

            return result;
        };

        const today = new IPeriod({days: 0}, 'today').toString();
        const yesterday = new IPeriod({days: -1}, 'yesterday').toString();
        const currWeek = () => new IPeriod({days: -(d.getDay() - 1)}, 'today').toString();
        const prevWeek = () =>
            new IPeriod(new IDate(getPrevWeek().start), new IDate(getPrevWeek().end)).toString();
        const currMonth = () => new IPeriod(new IDate(getCurrMonth()), 'now').toString();
        const prevMonth = () =>
            new IPeriod(new IDate(getPrevMonth().start), new IDate(getPrevMonth().end)).toString();
        const currQuarter = () =>
            new IPeriod(
                new IDate(getCurrQuarter().start),
                new IDate(getCurrQuarter().end),
            ).toString();
        const prevQuarter = () =>
            new IPeriod(
                new IDate(getPrevQuarter().start),
                new IDate(getPrevQuarter().end),
            ).toString();

        switch (type) {
            case 'today':
                return today;
            case 'yesterday':
                return yesterday;
            case 'currWeek':
                return currWeek();
            case 'prevWeek':
                return prevWeek();
            case 'currMonth':
                return currMonth();
            case 'prevMonth':
                return prevMonth();
            case 'currQuarter':
                return currQuarter();
            case 'prevQuarter':
                return prevQuarter();
            default:
                return null;
        }
    };

    _getCategoryList = () => {
        return []
            .concat({
                id: ALL_CATEGORIES,
                name: this.l10n('STATEMENTS_CAT_ALL'),
            })
            .concat(this.settings.get('categories'));
    };

    _setOpenCalendar = open => {
        this.setState({openCalendar: open});
    };

    _setOpenFilters = open => {
        this.setState({
            openFilters: open,
        });
    };

    _clearFilters = () => {
        this.setState({
            quarter: null,
            quarterIndex: 0,
            activeFilterId: null,
        });
    };

    _clearPeriod = () => {
        this.setState({
            quarter: null,
            collection: [],
            quarterIndex: 0,
        });
    };

    _setActiveFilterId = id => {
        if (id !== this.state.activeFilterId) this.setState({activeFilterId: id});
    };

    _periodStringify = value => {
        if (value) {
            value = value instanceof IPeriod ? value : new IPeriod(value);
            return value.toString('dd fs yyyy', ' - ');
        } else {
            return value;
        }
    };

    _getDateInput = data => {
        this.setState({dateInput: data});
    };

    _changeFilterPeriod = type => {
        const period = this.getPeriodFromType(type);

        this.setState({period});
    };

    static propTypes = {
        period: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
        category: PropTypes.string,
        model: PropTypes.object,
    };

    static defaultProps = {
        period: new IPeriod({days: -30}, 'today').toString(),
        category: null,
    };

    static displayName = 'Statements.Views.Main';
}

export default Main;
